import { useAuthLoading, useUser } from "@/stores/auth";
import { Loader } from "@mantine/core";
import type { ReactNode } from "react";
import { Navigate } from "react-router";

export function AuthProtectedRoute({ children }: { children: ReactNode }) {
  const user = useUser();
  const loading = useAuthLoading();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Loader size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
